import { render, staticRenderFns } from "./Esim-plus-web.vue?vue&type=template&id=90fe67a6&scoped=true"
import script from "./Esim-plus-web.vue?vue&type=script&lang=js"
export * from "./Esim-plus-web.vue?vue&type=script&lang=js"
import style0 from "./Esim-plus-web.vue?vue&type=style&index=0&id=90fe67a6&prod&lang=less"
import style1 from "./Esim-plus-web.vue?vue&type=style&index=1&id=90fe67a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fe67a6",
  null
  
)

export default component.exports